<div class="container-fluid">
  @if (loading) {
    <loader [config]="{ overlay: false, text: 'Caricamento dati in corso...' }"></loader>
  }

  @if (error) {
    <div class="alert alert-danger">
      {{ error }}
    </div>
  }

  @if (!loading && !error && employee) {
    <div>
      <div class="row">
        <div class="col-sm-5">
          <div class="row g-3">
            <div class="col-12">
              <div class="card shadow-sm">
                <div class="card-header">
                  <h3 class="card-title">Personnel Details</h3>
                </div>
                <div class="card-body">
                  <employee-consultants-residential-info-form [employee]="employee" [readonly]="readonly"></employee-consultants-residential-info-form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-7">
          <div class="col-12">
            <div class="card shadow-sm">
              <div class="card-header">
                <h3 class="card-title">General Info</h3>
              </div>
              <div class="card-body">
                <employee-consultants-general-info-form [employee]="employee" [readonly]="readonly"></employee-consultants-general-info-form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-md-12">
          <div class="card shadow-sm">
            <div class="card-header">
              <h3 class="card-title">Previous Jobs</h3>
            </div>
            <div class="card-body">
              <employee-consultants-previous-jobs-form [employeeId]="employeeId" [employee]="employee"
              [employeeWorkCustomerList]="employeeWorkCustomerList" [readonly]="readonly"></employee-consultants-previous-jobs-form>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-md-12">
          <div class="card shadow-sm">
            <div class="card-header">
              <h3 class="card-title">Documents</h3>
            </div>
            <div class="card-body">
              <employee-documents [employeeId]="employeeId" [readonly]="readonly"></employee-documents>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <notes-customers-form [readonlyCustomerNotes]="readonly" [customer]="employee.employeeNoteList"
            [noteServiceMethod]="employeeConsultantsService" [addNoteMethod]="'createNotes'"
          [deleteNoteMethod]="'deleteNotes'" [sectionAttribute]="'employeeId'"></notes-customers-form>
        </div>
      </div>
    </div>
  }
</div>
